(function(e) {

	var obj = {
		init: function() {
          this.shopifyParam();
          this.initSidebar();
          this.initToolbar();
          this.initSidebarMenuEvent();
          this.initWishlist();
          this.initShowMore();
      	},
        initSidebar: function() {
          if (e(".collection-list").length > 0) {
            obj.typeEvent();
            obj.tagsEvent();
            obj.colorEvent();
            obj.sizeEvent();
            obj.priceEvent();
            obj.clearAllFiltersEvent();
          }
        },
        initToolbar: function() {
          if (e(".filters-panel").length > 0) {
            obj.initSortbyEvent();
            obj.initDirectionSorting();
            obj.initSortbyState();
            obj.initGridOrListEvent();
            obj.initPerpageEvent();
            obj.initPerpageSelect();
            obj.initPaginationEvent();
		  }
        },
        initWishlist: function() {
          obj.buttonAddEvent();
          obj.buttonRemoveEvent();
        },
        initShowMore: function() {
          obj.initShowMoreEvent();
        },
        shopifyParam: function() {
          Shopify.queryParams = {};
          if (location.search.length) {
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
              aKeyValue = aCouples[i].split('=');
              if (aKeyValue.length > 1) {
                Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
              }
            }
          }
        },
        clearShopifyParam: function() {
          delete Shopify.queryParams.q;
          delete Shopify.queryParams.type;
          delete Shopify.queryParams.tag;
          delete Shopify.queryParams.constraint;
          delete Shopify.queryParams.page;
        },
      	// Sort By
        initSortbyState: function() {
          if (e(".sort-select").length > 0) {
            if (Shopify.queryParams.sort_by) {
              var sortby = Shopify.queryParams.sort_by;
              obj.setSortLinksProperty(sortby);
              var text = e("[href="+sortby+"]:first").text();
              e(".sort-select .value").text(text);
              e(".sort-select .selected").removeClass("selected");
              e("[href="+sortby+"]").addClass("selected");
            }
            else {
              if(e('.sort-select a').hasClass("selected")) {
                obj.setSortLinksProperty(e('.sort-select .selected').attr('href'));
                e('.sort-select .value').text(e(".sort-select .selected").html());
              }
              else
              {
                e('.sort-selected-category').hide();
                e('.sort-select a').first().addClass('selected');
              }
            }
          }
        },
        initSortbyEvent: function() {
          if (e(".sort-select").length > 0) {
            e('.sort-select a').each(function() {
              e(this).click(function(event, param) {
                if(!e(this).hasClass('selected') || param == "custom") {
                  e('.sort-select .value').text(e(this).html());
                  Shopify.queryParams.sort_by = e(this).attr("href");

                  var url = location.pathname + "?" + e.param(Shopify.queryParams).replace(/\+/g, '%20');
                  obj.ajaxClick(url);

                  e(".sort-select .selected").removeClass("selected");
                  e(this).addClass("selected");

                  switch(e(this).attr("href")) {
                    case "manual":
                    case "best-selling":
                      e('.sort-selected-category').hide();
                      break;
                    default:
                      e('.sort-selected-category').show();
                  }
                }
                event.preventDefault();
              });
            });
          }
        },
        //Change order sorting
        initDirectionSorting: function() {
          if (e(".sort-selected-category").length > 0) {
            e(".sort-selected-category").each(function() {
              e(this).click(function(event) {
                if(e(this).hasClass("up")) {
                  e('.sort-selected-category').removeClass('up').addClass('down');
                  e(".sort-select .dropdown-menu li:nth-child(2) a").attr("href", "price-descending");
                  e(".sort-select .dropdown-menu li:nth-child(3) a").attr("href", "title-ascending");
                  e(".sort-select .dropdown-menu li:nth-child(4) a").attr("href", "created-descending");
                }
                else
                {
                  e('.sort-selected-category').removeClass('down').addClass('up');
                  e(".sort-select .dropdown-menu li:nth-child(2) a").attr("href", "price-ascending");
                  e(".sort-select .dropdown-menu li:nth-child(3) a").attr("href", "title-descending");
                  e(".sort-select .dropdown-menu li:nth-child(4) a").attr("href", "created-ascending");
                }      
                event.preventDefault();

                e(".sort-select .selected").first().trigger('click', ["custom"]);
              });
            });
          }
        },
  		// SELECT GRID TYPE
        initGridOrListEvent: function() {
          if (e(".view-mode").length > 0) {
            var viewGrid = e(".view-grid"),
                viewList = e(".view-list"),
                productList = e(".products-list");

            viewGrid.click(function (event) {
              if(!e(this).hasClass("selected")) {
                delete Shopify.queryParams.grid;
                var n = jQuery.param(Shopify.queryParams) == "" ? "" : "?" + e.param(Shopify.queryParams).replace(/%2B/g, "+");
                var url = location.pathname + n;
                history.pushState({
                  param: Shopify.queryParams
                }, url, url);

                obj.ajaxClick(url);
              }
              event.preventDefault();
            });

            viewList.click(function (event) {
              productList.removeClass("products-list-in-column").addClass("products-list-in-row");
              viewGrid.removeClass("selected");
              viewList.addClass("selected");

              Shopify.queryParams.grid = "list";
              var url = location.pathname + "?" + jQuery.param(Shopify.queryParams).replace(/%2B/g, "+");
              history.pushState({
                param: Shopify.queryParams
              }, url, url);

              event.preventDefault();
              $(window).trigger("resize");
            });

            if(obj.getUrlValue("grid", location.search) == "list")
            {
              viewList.trigger("click");
            };
          };
        },
      	// Show Grid
        initPerpageEvent: function () {
          if (e(".perpage-select").length > 0) {
            e(".perpage-select .dropdown-menu a").click(function(event) {
              if(!e(this).hasClass('selected')) {
                delete Shopify.queryParams.page;

                e(".perpage-select .value").text(e(this).html());
                Shopify.queryParams.view = e(this).attr("href");

                var url = location.pathname + "?" + e.param(Shopify.queryParams).replace(/%2B/g, "+");
                obj.ajaxClick(url);

                $(".perpage-select .selected").removeClass("selected");
                $(this).addClass("selected");
              }

              event.preventDefault()
            });
          }
        },
        initPerpageSelect: function() {
          if (e(".perpage-select").length > 0) {
            var text = e(".perpage-select .value").first().text();
            e("[href="+text+"]").addClass("selected");
          }
        },
        initPaginationEvent: function() {
          if (e(".pagination").length > 0) {
            e(".pagination a").click(function(event) {
              if(!e(this).hasClass("selected")) {
                var value = e(this).attr("href").match(/page=\d+/g);
                if (value) {
                  var currentpage = parseInt(value[0].match(/\d+/g));
                  Shopify.queryParams.page = currentpage;
                  if (Shopify.queryParams.page) {
                    var url = location.pathname + "?" + e.param(Shopify.queryParams).replace(/\+/g, '%20')
                    obj.ajaxClick(url);
                  }
                }
              }
              event.preventDefault();
            });
          };
        },
        initShowMoreEvent: function() {
          if (e(".show-more a").length > 0) {
            e(".show-more a").click(function(event) {
              if (!e(this).hasClass("disabled")) {
                obj.showMoreHandler()
              }
              event.preventDefault();
            })
          }
        },
      	showMoreHandler: function() {
          var scrollURL = e('.show-more a').last().attr("href");
          e.ajax({
            type: "GET",
            url: scrollURL,
            beforeSend: function() {
              obj.showPreloader();
            },
            success: function(data) {
              obj.hidePreloader();
              if (e(data).find(".show-more a").length > 0) {
				e(".show-more").replaceWith(e(data).find(".show-more"));
                if(e(".show-more a").attr('href')) {
                  obj.initShowMoreEvent();
                }
              }
              else {
                if(e(".show-more a").length > 0) {
                  e(".show-more a").remove();
                }
              }
              if (e(data).find(".products-list").length > 0) {
                e(".products-list").append(e(data).find(".products-list").html());
                var maxHeight = 0;
                $(".product-preview .preview-image").each(function () {
                  maxHeight = Math.max(maxHeight, $(this).find("img").height());
                });
                
                var content = e(data).find(".pag_limit_page:first-child").first();
                e(".pag_limit_page:first-child").replaceWith(content);
                
                if(e(".spr-badge").length > 0) {
                  e.getScript("http://productreviews.shopifycdn.com/assets/v4/spr.js");
                }
                $(window).trigger("load");
                $(".preview.hover-slide .preview-image").each(function () {
                  $(this).css({
                    "height": maxHeight
                  })
                })
              }
            },
            error: function(XMLHttpRequest, textStatus) {
              obj.hidePreloader();
              alert("error");
            },
            dataType: "html"
          })
        },
        // Menu Click
        initSidebarMenuEvent: function() {
          if (e(".collection-list").length > 0) {
            $('.expander-list a').each(function() {
              e(this).click( function(event) {
                e(".expander-list li").removeClass("selected");
                $(this).parent().parent().addClass("selected");
                obj.clearShopifyParam();

                var link = e(this).attr("href");
                var param = e.param(Shopify.queryParams).replace(/%2B/g, "+");
                param = param != "" ? "?" + param : "";
                var newURL = link + param;

                obj.ajaxClick(newURL);
                event.preventDefault();
              });
            })
          }
        },
        clearSelectSidebarMenu: function() {
			e(".expander-list .selected").removeClass('selected');
        },
      	// Type Click
        typeEvent: function() {
          if (e(".type-filter").length > 0) {
            e('.type-filter a').click(function(event) {
			  obj.clearSelectSidebarMenu();
              obj.clearShopifyParam();
              var n = e.param(Shopify.queryParams) == "" ? "" : '&' + e.param(Shopify.queryParams);
			  var newURL = e(this).attr('href').replace(' ', "+") + n;
			  obj.ajaxClick(newURL);
              event.preventDefault();
            });
          };
        },
      	// Tags Click
        tagsEvent: function() {
          if (e(".tag-filter").length > 0) {
            e('.tag-filter a').click(function(event) {
              e('.tag-filter a').removeClass('active');
              e(this).addClass('active');
              obj.clickHandler();
              event.preventDefault();
            });
          };
        },
        // Filter Block Click
        colorEvent: function() {
          if (e(".color-filter").length > 0) {
            e('.color-filter a').click(function(event) {
              e('.color-filter li').removeClass('active');
              e(this).parent().addClass('active');
              obj.clickHandler();
              event.preventDefault();
            });
          };
        },
        sizeEvent: function() {
          if (e(".size-filter").length > 0) {
            e('.size-filter a').click(function(event) {
              e('.size-filter li').removeClass('active');
              e(this).parent().addClass('active');
              obj.clickHandler();
              event.preventDefault();
            });
          };
		},
        priceEvent: function() {
          if (e(".price-filter").length > 0) {
            e('.price-filter a').click(function(event) {
              e('.price-filter li').removeClass('active');
              e(this).parent().addClass('active');
              obj.clickHandler();
              event.preventDefault();
            });
          };
        },
        // Filters Click Handler
        clickHandler: function() {
          delete Shopify.queryParams.page;
          var newTags = [];

          obj.saveNewTag(".color-filter .active a", newTags);
          obj.saveNewTag(".size-filter .active a", newTags);
          obj.saveNewTag(".price-filter .active a", newTags);
          obj.saveNewTag(".tag-filter .active", newTags);

		  var collHandle = obj.getUrlSubcategory('/collections/', location.pathname);
          if(collHandle != 'type' && location.search.length == 0)
          {
            var newURL = '/collections/' + collHandle;
            if (newTags.length) {
              newURL += '/' + newTags.join('+');
            }
            var search = e.param(Shopify.queryParams);
            if (search.length) {
              newURL += '?' + search;
            }
          }
          else
          {
            if (newTags.length) {
              newTags = newTags.join('+');
            }
            Shopify.queryParams.constraint = newTags.replace(/%5B%5D/g, "");
            var newURL = location.pathname + "?" + e.param(Shopify.queryParams).replace(/%2B/g, "+");
          }
          
		  obj.ajaxClick(newURL);
        },
        saveNewTag: function(data, newTags) {
          if (e(data).attr("href")) {
            newTags.push(e(data).attr("href"));
          }
        },
      	// Clear Filters
        clearAllFiltersEvent: function() {
          if (e('.filter-clear-all').length > 0) {
            e('.filter-clear-all a').click(function(event) {
              e(this).off("click");
              delete Shopify.queryParams.constraint;

              var collHandle = obj.getUrlSubcategory('/collections/', location.pathname);
              var collHandle2 = obj.getUrlSubcategory('/collections/'+collHandle+'/', location.pathname);
              if(collHandle2 != '') {
                var n = e.param(Shopify.queryParams) == '' ? '' : "?" + e.param(Shopify.queryParams);
              	var newURL = '/collections/' + collHandle + n;
              }
              else
              {
              	var newURL = location.pathname + "?" + e.param(Shopify.queryParams);
              }
              obj.ajaxClick(newURL);
              event.preventDefault();
            });
          };
        },
        //AJAX
        ajaxClick: function(url) {
          history.pushState({
            param: Shopify.queryParams
          }, url, url);
          obj.getCollectionContent(url);
        },
        getCollectionContent: function(url) {
          delete Shopify.queryParams.page;
          var params = {
            type: "get",
            url: url,
            beforeSend: function() {
              obj.showPreloader();
            },
            success: function(data) {
              obj.hidePreloader();
              obj.pageData(data);
              obj.paginationControl(data);
              obj.shopifyParam();
              obj.initSidebar();
              obj.initToolbar();
              obj.initWishlist();
              obj.initShowMore();
            },
            error: function(XMLHttpRequest, textStatus) {
              obj.hidePreloader();
              alert("error")
            }
          }
          jQuery.ajax(params);
        },
        //Get and show new content
        pageData: function(data) {
          var current_class = ".content-sort";
          var content = e(data).find(current_class);
          e(current_class).empty();
          e(current_class).append(content.html());
          if(current_class == ".sort-types"){
            e(".pagination").remove();
            e(".pag_limit_page").text(e(".products-list .product-preview").length);
          }

          var content = e(data).find(".breadcrumbs");
          e(".breadcrumbs").replaceWith(content);

          var content = e(data).find(".sidebar-filter");
          e(".sidebar-filter").replaceWith(content);

          var content = e(data).find(".collection-description");
          e(".collection-description").replaceWith(content);
          
          content = null;
          data = null;

          if(e(".shopify-product-reviews-badge").length > 0) {
          	e.getScript("http://productreviews.shopifycdn.com/assets/v4/spr.js");
          }
          
          $(window).trigger("load");
          $(window).trigger("resize");
        },
      	// wishlist
        buttonAddEvent: function() {
          if (e(".add-in-wishlist").length > 0) {
            e('.add-in-wishlist').each(function() {
              e(this).click(function(event) {
                event.preventDefault();
                var variant_id = e(this).attr('id');//remove after success, and get object not a link
                var form = e(this).parent();
                var _this = this;
                e.ajax({
                  type: "POST",
                  url: "/contact",
                  data: form.serialize(),
                  beforeSend: function() {
                    obj.showPreloader();
                  },
                  success: function(data) {
                    obj.hidePreloader();
                    if(e(_this).hasClass('wishlist-text-type')) {
                    	form.after( '<a href="/pages/wishlist"><i class="icon-heart"></i></a> <a href="/pages/wishlist">'+e(_this).last().text()+'</a>' );
                    }
                    else {
                    	form.after( '<a href="/pages/wishlist" class="circle"><span class="icon-heart"></span></a>' );
                    }
                    
                    form.remove();
                    obj.updateWishlistPopupBox(variant_id);
                  },
                  error: function(XMLHttpRequest, textStatus) {
                    obj.hidePreloader();
                    alert("error");
                  }
                });
              });
            });
          }
        },
      	//remove from wishlist page
        buttonRemoveEvent: function() {
          if (e(".product-remove").length > 0) {
            e('.product-remove a').each(function() {
              e(this).click(function(event) {
                event.preventDefault();
                var form = e("#wishlist-remove .contact-form");
                var item = e(this).parent().parent().parent();
                var tagID = e(this).attr('id');
                $('#remove-value').val(tagID);
                e.ajax({
                  type: "POST",
                  url: "/contact",
                  data: form.serialize(),
                  beforeSend: function() {
                    obj.showPreloader();
                  },
                  success: function(data) {
                    obj.hidePreloader();
                    item.fadeOut(500);
                    setTimeout(obj.removeItem, 500, data, item);
                  },
                  error: function(XMLHttpRequest, textStatus) {
                    obj.hidePreloader();
                    alert("error");
                  }
                });
              });
            });
          }
        },
        removeItem: function(data, item) {
          item.remove();
          if(e('.wishlist-table tbody tr').length <= 1 )
          {
            var content = e(data).find('.wishlist-page');
            e('.wishlist-page').replaceWith(content);
          }
        },
      	// Utils
        showPreloader: function() {
          e(".custom-loader").show();
        },
        hidePreloader: function() {
          e(".custom-loader").hide();
        },
      	updateWishlistPopupBox: function(variant_id) {
            var img = $('.'+variant_id).find('.preview-image');
            var title = $('.'+variant_id+' .title').text();
            e('#popup-box-wishlist .product-img').empty();
            e('#popup-box-wishlist .product-img').append(img.html());
            e('#popup-box-wishlist .product-img img').removeClass('animate');
            e('#popup-box-wishlist .product-img img').removeClass('scale');
            e('#popup-box-wishlist .product-img img').removeClass('animated');
            if(e('#popup-box-wishlist .product-img img').length > 1)
            {
              e('#popup-box-wishlist .product-img img:first').remove();
            }
            e('#popup-box-wishlist .popup-title').html(title);
            e.fancybox.open("#popup-box-wishlist");
        },
        setSortLinksProperty: function(sortby) {
          switch(sortby) {
            case "price-ascending":
            case "title-descending":
            case "created-ascending":
              e('.sort-selected-category').removeClass('down').addClass('up');
              e(".sort-select .dropdown-menu li:nth-child(2) a").attr("href", "price-ascending");
              e(".sort-select .dropdown-menu li:nth-child(3) a").attr("href", "title-descending");
              e(".sort-select .dropdown-menu li:nth-child(4) a").attr("href", "created-ascending");
              break;
            case "manual":
            case "best-selling":
              e('.sort-selected-category').hide();
              break;
          }
        },
        calculateProductsInRowMain: function () {
          var calculateProductsInRow = function (row) {
            e(".product-view-ajax-container.temp").each(function () {
              e(this).remove()
            });
            var productsInRow = 0;
            e(row).children(".product-preview").each(function () {
              if (e(this).prev().length > 0) {
                if (e(this).position().top != e(this).prev().position().top) return false;
                productsInRow++
              } else productsInRow++
                });
            e(row).children(":nth-child(" + productsInRow + "n)").after('<div class="product-view-ajax-container temp"></div>')
          };
          e(".products-list").each(function () {
            calculateProductsInRow(this)
          });
        },
		paginationControl: function(data) {
          var value = $(data).find(".pagination").first();
          $(".pagination").replaceWith(value);
        },
        getUrlSubcategory: function (category, url) {
          var str = url;
          var n = str.indexOf(category);
          if(n < 0)
            return "";
          str = str.slice(n + category.length, str.length);
          var m = str.indexOf("/") > -1 ? str.indexOf("/") : str.length;
          str = str.slice(0, m).toLowerCase();
          return str.replace(name+"=", "");
        },
        getUrlValue: function (name, url) {
          var str = url;
          var n = str.indexOf(name);
          if(n < 0)
            return "";
          str = str.slice(n, str.length);
          var m = str.indexOf("&") > -1 ? str.indexOf("&") : str.length;
          str = str.slice(0, m).toLowerCase();
          return str.replace(name+"=", "");
        }
  	}

    e(document).ready(function() {
      	obj.init();
    });

})(jQuery)